import { useTranslation } from "react-i18next";
import Button from "./Button";

interface Props {
  error: unknown;
  resetError?: () => void;
}

export default function ErrorFallback({ resetError }: Props) {
  const { t } = useTranslation("common");

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-xl bg-white p-8 text-center shadow-lg">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-100 text-red-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-7"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        <h1 className="mb-2 text-xl font-semibold text-slate-900">
          {t("errorBoundary.title")}
        </h1>

        <p className="mb-6 text-sm text-slate-500">
          {t("errorBoundary.description")}
        </p>

        <Button
          onClick={() => {
            resetError?.();
            window.location.reload();
          }}
        >
          {t("errorBoundary.reload")}
        </Button>
      </div>
    </div>
  );
}
